import { useMediaQuery } from "react-responsive";

export default function useScreenSize() {
	const isExtraSmall = useMediaQuery({ query: "(max-width: 575px)" });
	const isSmall = useMediaQuery({
		query: "(min-width: 576px) "
	});
	const isMedium = useMediaQuery({
		query: "(min-width: 768px) "
	});
	const isLarge = useMediaQuery({
		query: "(min-width: 992px) "
	});
	const isExtraLarge = useMediaQuery({
		query: "(min-width: 1200px)"
	});
	const isExtraExtraLarge = useMediaQuery({
		query: "(min-width: 1400px)"
	});
	const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
	const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });

	const screenSizes = {
		isExtraSmall,
		isSmall,
		isMedium,
		isLarge,
		isExtraLarge,
		isExtraExtraLarge,
		isPortrait,
		isRetina
	};

	return screenSizes;
}
